import React, { useEffect, useState } from "react";
import Ratings from "../Ratings";
import { AiFillHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_wishlist_products,
  remove_wishlist,
  messageClear,
} from "../../store/reducers/cardReducer";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
const Wishlist = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { wishlist, successMessage } = useSelector((state) => state.card);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    dispatch(get_wishlist_products(userInfo.id));
  }, []);
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
  }, [successMessage]);

  return (
    <div
      className={`w-full ${wishlist.length === 0 ? "h-full" : "grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6"}`}
    >
      {wishlist.length > 0 ? (
        wishlist.map((p, i) => (
          <motion.div
            key={i}
            className="hover:border hover:border-secondary/20 group transition-all duration-300 hover:bg-card rounded-3xl hover:shadow-sm hover:-mt-1"
            onMouseEnter={() => setHoveredCard(i)}
            onMouseLeave={() => setHoveredCard(null)}
            initial={{ opacity: 0.9, scale: 1 }}
            animate={{
              opacity: hoveredCard === i ? 1 : 0.9,
              scale: hoveredCard === i ? 1.02 : 1,
              transition: { duration: 0.3 },
            }}
          >
            <div className="relative transition-opacity duration-500 ease-in-out overflow-hidden">
              {p.discount !== 0 && (
                <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                  -{p.discount}%
                </div>
              )}

              <img
                className="sm:w-full w-full rounded-3xl group-hover:rounded-b-none transition-all duration-200 h-[240px] object-cover"
                src={p.image}
                alt="product image"
              />
              <ul className="flex transition-all duration-500 -bottom-11 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
                <li
                  onClick={() => dispatch(remove_wishlist(p._id))}
                  className="w-[44px] h-[44px] cursor-pointer bg-card text-secondary flex justify-center items-center rounded-full hover:bg-secondary hover:text-card hover:rotate-[720deg] transition-all"
                >
                  <AiFillHeart className="text-xl" />
                </li>
                <Link
                  to={`/product/details/${p.slug}`}
                  className="w-[44px] h-[44px] cursor-pointer bg-card text-secondary flex justify-center items-center rounded-full hover:bg-secondary hover:text-card hover:rotate-[720deg] transition-all"
                >
                  <FaEye className="text-xl" />
                </Link>
              </ul>
            </div>
            <div className="py-3 text-primary px-2">
              <h2 className="text-lg font-medium">{p.name}</h2>
              <div className="flex justify-start items-center gap-3 text-xl mt-1">
                {p.discount !== 0 ? (
                  <>
                    <p className="line-through">Rs.{p.price}</p>
                    <p className="font-medium">
                      Rs.
                      {p.price - Math.floor((p.price * p.discount) / 100)}{" "}
                    </p>
                  </>
                ) : (
                  <p className="font-medium">Rs.{p.price}</p>
                )}
                <div className="flex">
                  <Ratings ratings={p.rating} />
                </div>
              </div>
            </div>
          </motion.div>
        ))
      ) : (
        <div className="flex items-center justify-center h-full capitalize">
          No Products added
        </div>
      )}
    </div>
  );
};

export default Wishlist;
